import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
          <div className="prose max-w-none">
            <p className="text-gray-600 mb-6">Last updated: October 24, 2026</p>
            
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Information We Collect</h2>
            <p className="mb-4">We collect information you provide directly to us, such as when you create an account, subscribe to our services, or contact us.</p>
            <ul className="list-disc pl-6 mb-6">
              <li>Personal information (name, email address, phone number)</li>
              <li>Payment information (processed securely through Stripe)</li>
              <li>Usage data and preferences</li>
              <li>Communication records</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Analytics &amp; Automatically Collected Data</h2>
            <p className="mb-4">When you visit our website, we and our analytics provider (PostHog) automatically collect limited technical and usage data to measure traffic and improve the site, including from visitors who never create an account:</p>
            <ul className="list-disc pl-6 mb-6">
              <li>Pages viewed, referring site, and navigation paths</li>
              <li>Approximate location derived from IP address, device and browser type</li>
              <li>Anonymized interaction events (e.g., clicks and form submissions) and aggregate heatmaps</li>
              <li>With your consent only, anonymized session replays in which all text and input fields are masked (no passwords, email addresses, or financial data are recorded)</li>
            </ul>
            <p className="mb-6">We honor the "Do Not Track" browser signal, and session replay is never enabled without your explicit consent, which you may withdraw at any time.</p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">How We Use Your Information</h2>
            <ul className="list-disc pl-6 mb-6">
              <li>Provide and maintain our stock information services</li>
              <li>Process payments and manage subscriptions</li>
              <li>Send service-related communications</li>
              <li>Improve our services and user experience</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Information Sharing</h2>
            <p className="mb-4">We do not sell, trade, or rent your personal information to third parties. We may share information in the following circumstances:</p>
            <ul className="list-disc pl-6 mb-6">
              <li>With service providers (payment processing, email delivery)</li>
              <li>With our analytics provider (PostHog) to measure and improve site usage</li>
              <li>To comply with legal requirements</li>
              <li>To protect our rights and safety</li>
              <li>With your consent</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Data Security</h2>
            <p className="mb-6">We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Your Rights</h2>
            <p className="mb-4">You have the right to:</p>
            <ul className="list-disc pl-6 mb-6">
              <li>Access and update your personal information</li>
              <li>Delete your account and personal data</li>
              <li>Opt out of marketing communications</li>
              <li>Request data portability</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Contact Us</h2>
            <p className="mb-4">If you have questions about this Privacy Policy, please contact us at:</p>
            <p className="mb-2">Email: privacy@gandalstock.com</p>
            <p className="mb-6">Address: GandalStock, Inc.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
